import Logo from 'domain/entity/logo';

export const DEFAULT_REPORT_LOGO_URL = 'https://app.dexma.com/img/custom/dexcell/dexma-logo.png';

export const DEFAULT_REPORT_LOGO = new Logo(
    'default-energy-logo-url',
    'Energy',
    DEFAULT_REPORT_LOGO_URL
);

export const isDefaultReportLogo = (logoImageUrl?: string): boolean => logoImageUrl === DEFAULT_REPORT_LOGO.imgResourceKey;
